import React from 'react';
import PackageCard from './PackageCard';
import { ChangeSubscriptionDetails } from './types';

export default function PackageCards({
    changeSubscriptionDetails,
    isTrialUpgrade = false,
    redirectToSubscriptionStatusPage = true,
}: {
    changeSubscriptionDetails: ChangeSubscriptionDetails;
    isTrialUpgrade?: boolean;
    redirectToSubscriptionStatusPage?: boolean;
}) {
    const cardSize = changeSubscriptionDetails.externalPlans.length > 4 ? 'sm' : 'md';
    // plan.functionalityHeader can be removed from query
    // plan.functionalities can be removed from query
    return (
        <div className="pt-8 flex" style={{ width: 'fit-content' }}>
            {changeSubscriptionDetails.externalPlans
                .sort((a, b) => b.planId - a.planId)
                .map((plan, idx) => (
                    <PackageCard
                        key={plan.planId}
                        size={cardSize}
                        planId={plan.planId}
                        highlighted={plan.highlighted}
                        isDowngrade={plan.isDowngrade}
                        isTrialUpgrade={isTrialUpgrade}
                        className={idx === changeSubscriptionDetails.externalPlans.length - 1 ? '' : 'mr-4'}
                        header={plan.header}
                        contentText={plan.contentText}
                        readMoreLink={plan.readMoreLink}
                        prices={plan}
                        disabled={plan.disabled}
                        disabledReason={plan.disabledReason}
                        functionalityHeader={plan.functionalityHeader}
                        functionalities={plan.functionalities}
                        redirectToSubscriptionStatusPage={redirectToSubscriptionStatusPage}
                    />
                ))}
        </div>
    );
}
